import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const NotFound = () => {
    const {t} = useTranslation();
  return (
    <div style={{ textAlign: 'center', padding: '180px 20px', fontFamily: 'sans-serif' }}>
      <h1>404</h1>
      <h2>{t('notFound.title')}</h2>
      <p>{t('notFound.description')}</p>
      <Link to="/" style={{ color: '#007bff', textDecoration: 'underline' }}>
        {t('notFound.link')}
      </Link>
    </div>
  );
};